// src/components/Presentation/EditableSlateRenderer.js
import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import EditableSlateContent from './SlateContent';

const EditableSlateRenderer = ({ 
  slate, 
  isSelected, 
  onSelect, 
  selectedContentType,
  onUpdateSlate
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleUpdateContent = (newContent) => {
    onUpdateSlate({
      ...slate,
      content: newContent
    });
  };

  return (
    <div
      onClick={onSelect}
      className={`
        relative border-2 rounded-lg transition-all duration-200 cursor-pointer overflow-hidden
        ${isSelected 
          ? 'border-indigo-500 ring-2 ring-indigo-200 z-20' 
          : slate.type === 'empty' 
            ? 'border-dashed border-gray-300 hover:border-gray-400' 
            : 'border-gray-200 hover:border-gray-300'
        }
        ${selectedContentType && slate.type === 'empty' 
          ? 'bg-indigo-50 border-indigo-300 animate-pulse' 
          : ''
        }
      `}
      style={{
        gridColumn: `${slate.gridArea.x + 1} / span ${slate.gridArea.w}`,
        gridRow: `${slate.gridArea.y + 1} / span ${slate.gridArea.h}`,
        minHeight: '40px'
      }}
    >
      {slate.type === 'empty' ? (
        <div className="w-full h-full flex items-center justify-center">
          <div className="text-center text-gray-400">
            <Plus className="w-8 h-8 mx-auto mb-2" />
            <span className="text-sm font-medium">
              {selectedContentType ? `Click to add ${selectedContentType}` : 'Add content'}
            </span>
          </div>
        </div>
      ) : (
        <EditableSlateContent 
          slate={slate}
          isSelected={isSelected}
          onUpdateContent={handleUpdateContent}
          isEditing={isEditing}
          onStartEditing={() => setIsEditing(true)}
          onStopEditing={() => setIsEditing(false)}
        />
      )}
      
      {/* Selection indicator */}
      {isSelected && (
        <div className="absolute top-1 right-1 bg-indigo-600 text-white text-xs px-1 py-0.5 rounded">
          {slate.type}
        </div>
      )}
    </div>
  );
};

export default EditableSlateRenderer;